/* eslint-disable camelcase */
import { VueAuthPlugin } from "oidc-vue"
import { defineGlobals } from "vue-utils"

class AppAuthPlugin extends VueAuthPlugin {
	constructor() {
		super({
			clientId: "TaxRebateAuth",
			authority: "https://keycloak.submarine.gg/realms/TaxRebateAdmin",
			redirectUri: window.location.origin,
			postLogoutRedirectUri: window.location.origin,
			storagePrefix: "tr_admin",
			sessionExpireLoginType: "popup",
		})
	}

	getKeycloakManageUrl() {
		const realmUrl = this.options.authority
		return `${realmUrl}/account?referrer=${encodeURIComponent(this.options.clientId)}&referrer_uri=${encodeURIComponent(
			window.location.href
		)}`
	}
}

export const AppAuthContext = new AppAuthPlugin()
defineGlobals({
	AppAuthContext,
})
